import { r as registerInstance, h, H as Host } from './index-2b2e631a.js';
import { g as getFieldValue } from './utils-9a999346.js';
import './state-3cc1e9a3.js';

let SearchResultPGCourse = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  /**
   * On the range slide event, update the range state
   *
   * @param {event} event
   */
  getDeliveryMethodValue() {
    const value = getFieldValue(this.searchResult.Fields, 'StudyDeliveryMethod')
      .replace(/(^\w|\s\w)/g, m => m.toUpperCase())
      .replaceAll('-', ' ')
      .replaceAll('On campus', 'On-campus')
      .replaceAll('Online with on campus learning', 'Online with on-campus elements')
      .replaceAll('&', 'or');
    return value;
  }
  /**
   * Render element
   */
  render() {
    // Return element
    return (h(Host, { class: "search-result__inner" }, h("div", { class: "search-result__taxonomy" }, h("div", { class: "badge" }, getFieldValue(this.searchResult.Fields, 'StudyType'), " postgraduate programme")), h("slot", null), h("div", { class: "search-result__meta" }, h("dl", null, h("dt", null, "Modes of study"), h("dd", null, getFieldValue(this.searchResult.Fields, 'StudyModes')), h("dt", null, "Awards available"), h("dd", null, getFieldValue(this.searchResult.Fields, 'CourseAwards')), h("dt", null, "Delivery method"), h("dd", null, this.getDeliveryMethodValue())))));
  }
};

export { SearchResultPGCourse as search_result_pg_course };
